import { cn } from "@/lib/utils"

export interface AlgoBuilderMarkProps {
  size?: number
  className?: string
}

export function AlgoBuilderMark({ size = 20, className }: AlgoBuilderMarkProps) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 125 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="AlgoBuilder"
      className={cn("block shrink-0 text-foreground", className)}
    >
      <defs>
        <linearGradient
          id="abm-p0"
          x1="56.2634"
          y1="99.5705"
          x2="1.52755"
          y2="61.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="abm-p1"
          x1="71.5131"
          y1="25.5109"
          x2="111.798"
          y2="63.1697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="abm-p2"
          x1="103.845"
          y1="53.8061"
          x2="66.6255"
          y2="141.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="abm-p3"
          x1="42.1898"
          y1="69.4583"
          x2="23.7998"
          y2="-25.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>

      <g>
        <path
          d="M0 52.6843L0.0516929 70.5342C7.88329 70.5704 15.061 71.4207 22.2438 73.6435C44.7099 80.6455 53.5263 101.349 53.4513 123.89L71.2805 123.88C71.5441 112.512 69.6495 101.475 65.3409 91.0178C59.9802 78.4795 51.1639 68.2002 38.9641 61.5834C38.9641 61.5834 26.5732 55.039 0 52.6843Z"
          fill="url(#abm-p0)"
        />
        <path
          d="M125.135 71.2055L125.083 53.3557C117.252 53.3195 110.074 52.4691 102.891 50.2463C80.4251 43.2444 71.6088 22.541 71.6837 0L53.8545 0.010339C53.5909 11.3778 55.4855 22.4144 59.7942 32.872C65.1548 45.4104 73.9712 55.6897 86.1709 62.3064C86.1709 62.3064 98.5619 68.8509 125.135 71.2055Z"
          fill="url(#abm-p1)"
        />
        <path
          d="M125.135 52.6843L125.083 70.5342C117.252 70.5704 110.074 71.4207 102.891 73.6435C80.4251 80.6455 71.6088 101.349 71.6837 123.89L53.8545 123.88C53.5909 112.512 55.4855 101.475 59.7942 91.0178C65.1548 78.4795 73.9712 68.2002 86.1709 61.5834C86.1709 61.5834 98.5619 55.039 125.135 52.6843Z"
          fill="url(#abm-p2)"
        />
        <path
          d="M0 71.2055L0.0516929 53.3557C7.88329 53.3195 15.061 52.4691 22.2438 50.2463C44.7099 43.2444 53.5263 22.541 53.4513 0L71.2805 0.010339C71.5441 11.3778 69.6495 22.4144 65.3409 32.872C59.9802 45.4104 51.1639 55.6897 38.9641 62.3064C38.9641 62.3064 26.5732 68.8509 0 71.2055Z"
          fill="url(#abm-p3)"
        />
      </g>
    </svg>
  )
}
